import { modelFactory } from '~base/ModelFactory';
import ApiHelper from '~base/api/ApiHelper';
import FileTypesApiRepository from '~modules/fileTypes/FileTypesApiRepository';
import { DocumentFixedTypeModel } from '~modules/fileTypes/models/DocumentFixedTypeModel';
import { FileFormatModel } from '~modules/fileTypes/models/FileFormatModel';
import { FileModeEnum } from '~modules/fileTypes/types/FileModeEnum';

export default class FileTypesService {
  api: FileTypesApiRepository;

  constructor() {
    this.api = new FileTypesApiRepository();
  }

  // API

  getFileFormats = async (mode: FileModeEnum) => {
    const params = ApiHelper.getURLSearchParams(
      ApiHelper.getTrimStringValues({
        mode,
      }),
    );

    const { data } = await this.api.getFileFormats(params);

    return modelFactory.createList(FileFormatModel, data.data);
  };

  getDocumentFixedTypes = async (
    documentTypeId: number,
    documentId: number | undefined,
    mode: FileModeEnum,
    includeNonGroupType?: boolean,
  ) => {
    const params = ApiHelper.getURLSearchParams(
      ApiHelper.getTrimStringValues({
        documentTypeId,
        documentId,
        mode,
        includeNonGroupType,
      }),
    );

    const { data } = await this.api.getDocumentFixedTypes(params);

    return modelFactory.createList(DocumentFixedTypeModel, data.data);
  };
}
